import { Injectable, EventEmitter } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import {
  DataArray,
  SignalRService,
  SignalREventService,
} from "./../../shared/index";

import {
  FMIProduct,
  FMITemplate,
  FMIDivision,
  FMIPubType,
  FMILanguage,
  FMIModel,
  FMIProductSource,
  SectionPermission,
} from "./../index";

@Injectable()
export class FMIProductService {
  public fmiproductsChange: EventEmitter<FMIProduct[]> = new EventEmitter<
    FMIProduct[]
  >();
  public fmiproductChange: EventEmitter<FMIProduct> =
    new EventEmitter<FMIProduct>();

  public fmidivisionChange: EventEmitter<FMIDivision[]> = new EventEmitter<
    FMIDivision[]
  >();
  public fmitemplateChange: EventEmitter<FMITemplate[]> = new EventEmitter<
    FMITemplate[]
  >();
  public fmipubtypeChange: EventEmitter<FMIPubType[]> = new EventEmitter<
    FMIPubType[]
  >();
  public fmilanguageChange: EventEmitter<FMILanguage[]> = new EventEmitter<
    FMILanguage[]
  >();
  public fmimodelChange: EventEmitter<FMIModel[]> = new EventEmitter<
    FMIModel[]
  >();
  public fmiproductsourceChange: EventEmitter<FMIProductSource[]> =
    new EventEmitter<FMIProductSource[]>();

  public fmiproductCreated: EventEmitter<FMIProduct> =
    new EventEmitter<FMIProduct>();
  public fmiproductDeleted: EventEmitter<FMIProduct> =
    new EventEmitter<FMIProduct>();

  public fmiproducts: DataArray<FMIProduct> = new DataArray<FMIProduct>();
  public fmitemplates: DataArray<FMITemplate> = new DataArray<FMITemplate>();
  public fmidivisions: DataArray<FMIDivision> = new DataArray<FMIDivision>();
  public fmipubtypes: DataArray<FMIPubType> = new DataArray<FMIPubType>();
  public fmimodels: DataArray<FMIModel> = new DataArray<FMIModel>();
  public fmilanguages: DataArray<FMILanguage> = new DataArray<FMILanguage>();
  public fmiproductsources: DataArray<FMIProductSource> =
    new DataArray<FMIProductSource>();

  public pdfFMIChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public pdfFMIError: EventEmitter<string> = new EventEmitter<string>();
  public pdfAzureChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public pdfAzureError: EventEmitter<string> = new EventEmitter<string>();
  public coverImageUploaded: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  public totalFMIProducts = 0;

  constructor(
    private _signalRService: SignalRService,
    private _signalREventService: SignalREventService,
    private _http: HttpClient
  ) {
    this.registerOnServerEvents();
  }

  private onFMIProducts(info: any): void {
    this.totalFMIProducts = info.Data.Total;
    this.fmiproducts.init();

    for (const item of info.Data.FMIProducts) {
      const fmiproduct: FMIProduct = $.extend(new FMIProduct(), item);
      this.fmiproducts.push(fmiproduct);
    }

    this.fmiproductsChange.emit(this.fmiproducts.Data);
  }

  private onFMITemplates(info: any): void {
    this.fmitemplates.init();
    for (const item of info.Data.FMITemplates) {
      const fmitemplate: FMITemplate = $.extend(new FMITemplate(), item);
      this.fmitemplates.push(fmitemplate);
    }

    this.fmitemplateChange.emit(this.fmitemplates.Data);
  }

  private onFMIDivisions(info: any): void {
    this.fmidivisions.init();
    for (const item of info.Data.FMIDivisions) {
      const fmidivision: FMIDivision = $.extend(new FMIDivision(), item);
      this.fmidivisions.push(fmidivision);
    }

    this.fmidivisionChange.emit(this.fmidivisions.Data);
  }

  private onFMIPubTypes(info: any): void {
    this.fmipubtypes.init();
    for (const item of info.Data.FMIPubTypes) {
      const fmipubtype: FMIPubType = $.extend(new FMIPubType(), item);
      this.fmipubtypes.push(fmipubtype);
    }

    this.fmipubtypeChange.emit(this.fmipubtypes.Data);
  }

  private onFMIModels(info: any): void {
    this.fmimodels.init();
    for (const item of info.Data.FMIModels) {
      const fmimodel: FMIModel = $.extend(new FMIModel(), item);
      this.fmimodels.push(fmimodel);
    }

    this.fmimodelChange.emit(this.fmimodels.Data);
  }

  private onFMILanguages(info: any): void {
    this.fmilanguages.init();
    for (const item of info.Data.FMILanguages) {
      const fmilanguage: FMILanguage = $.extend(new FMILanguage(), item);
      this.fmilanguages.push(fmilanguage);
    }

    this.fmilanguageChange.emit(this.fmilanguages.Data);
  }

  private onFMIProductSources(info: any): void {
    this.fmiproductsources.init();
    for (const item of info.Data.FMIProductSources) {
      const fmiproductsource: FMIProductSource = $.extend(
        new FMIProductSource(),
        item
      );
      this.fmiproductsources.push(fmiproductsource);
    }
    this.fmiproductsourceChange.emit(this.fmiproductsources.Data);
  }

  private onFMIProductChange(info: any): void {
    const fmiproduct: FMIProduct = $.extend(new FMIProduct(), info.Data);
    if (this.fmiproducts.update(fmiproduct)) {
      this.fmiproductChange.emit(fmiproduct);
    }
  }

  private onCreateFMIProduct(data: any): void {
    const fmiproduct = $.extend(new FMIProduct(), data);
    this.fmiproductCreated.emit(fmiproduct);
  }

  private onFMIProductDelete(data: any): void {
    const fmiproduct = $.extend(new FMIProduct(), data);
    this.fmiproductDeleted.emit(fmiproduct);
  }

  private onFMIProductSave(data: any): void {
    const fmiproduct = $.extend(new FMIProduct(), data);
    this.fmiproductChange.emit(fmiproduct);
    //this.fmiproductChange.emit(data.FMIProduct);
    //this.fmiproductCreated.emit(data.FMIProduct);
    ////this._signalRService.invoke("EndSaveUser", data.User.Id);
  }

  public getFMIProducts(
    orderBy: string,
    ascending: boolean,
    productName: string,
    productDescription: string,
    fmiLanguage: string,
    division: string,
    createdBy: string,
    ableToPrint: boolean,
    notAbleToPrint: boolean
  ): void {
    this._signalRService.invoke(
      "FilterFMIProducts",
      orderBy,
      ascending,
      productName,
      productDescription,
      fmiLanguage,
      division,
      createdBy,
      ableToPrint,
      notAbleToPrint
    );
  }

  public getFMITemplates(): void {
    this._signalRService.invoke("GetFMITemplates");
  }

  public getFMIDivisions(): void {
    this._signalRService.invoke("GetFMIDivisions");
  }

  public getFMIPubTypes(): void {
    this._signalRService.invoke("GetFMIPubTypes");
  }

  public getFMIModels(): void {
    this._signalRService.invoke("GetFMIModels");
  }

  public getFMILanguages(): void {
    this._signalRService.invoke("GetFMILanguages");
  }

  public getFMIProductSources(): void {
    this._signalRService.invoke("GetFMIProductSources");
  }

  //public uploadFMIFile(): void {
  //    this._signalRService.invoke("ftpFileToFMI");
  //}

  public uploadPDF(
    inFile: FormData,
    uploadProManual: boolean,
    uploadFMI: boolean,
    isNonConforming: boolean,
    updatedFileName: string
  ): void {
    let headers = new HttpHeaders();
    let options = { headers: headers };

    // TODO: verify that this works and compare with changes made in 97ebf86 and 1ee3855

    // upload file to FMI
    if (uploadFMI) {
      try {
        this._http
          .post(
            window.document.location.origin + "/api/Manuals/UploadPDFtoFMI",
            inFile,
            options
          )
          .subscribe(
            (data) => {
              this.pdfFMIChange.emit(true);
            },
            (error) => {
              this.pdfFMIError.emit(error);
            },
            () => {
              console.log("upload completed to FMI");
            }
          );
      } catch (e) {
        this.pdfFMIError.emit(e.message);
      }
    }

    // upload file to Komatsu's Azure Storage
    if (uploadProManual) {
      try {
        //updatedFileName may have unsafe characters for a url
        const _updatedFileName = encodeURIComponent(updatedFileName);

        const url =
          window.document.location.origin +
          "/api/Manuals/UploadPDFtoAzure?isNonConforming=" +
          (isNonConforming ? "true" : "false") +
          "&updatedFileName=" +
          _updatedFileName;
        //make url safe
        const safeUrl = encodeURI(url);
        this._http.post(safeUrl, inFile, options).subscribe(
          (data) => {
            this.pdfAzureChange.emit(true);
          },
          (error) => {
            this.pdfAzureError.emit(error);
          },
          () => {
            console.log("upload completed to Azure");
          }
        );
      } catch (e) {
        this.pdfAzureError.emit(e.message);
      }
    }
  }

  public uploadCoverImage(inFile: FormData): void {
    let headers = new Headers();
    let options = { headers: headers };

    // upload file to FMI
    this._http
      .post(
        window.document.location.origin + "/api/Manuals/UploadCoverImage",
        inFile
      )
      .subscribe(
        (data) => {
          // Consume Files
          // ..
          this.coverImageUploaded.emit(true);
        },
        (error) => console.log(error),
        () => {
          console.log("cover image uploaded");
        }
      );
  }

  public createFMIProduct(
    fmiproduct: FMIProduct,
    template: string,
    model: string,
    currentUser: string,
    version: string
  ): void {
    const strExpirationDate = "";

    this._signalRService.invoke(
      "CreateFMIProduct",
      fmiproduct.Id,
      fmiproduct.FileMetadataID,
      fmiproduct.ProductSourceID,
      fmiproduct.ProductName,
      fmiproduct.ProductDescription,
      fmiproduct.PubType,
      fmiproduct.Language,
      template,
      model,
      fmiproduct.Division,
      fmiproduct.CDPrice,
      fmiproduct.BookPrice,
      fmiproduct.FlashDrivePrice,
      fmiproduct.ProManualTitle,
      fmiproduct.PublishToProManual,
      fmiproduct.ProManualPublicationNumber,
      strExpirationDate,
      fmiproduct.AllowPrinting,
      currentUser,
      fmiproduct.IsPulledFromMidlandFMI,
      version,
      fmiproduct.IsNonConformingDocument,
      fmiproduct.TitaniaUrl
    );
  }

  public deleteFMIProduct(fmiproductId: number): void {
    this._signalRService.invoke("DeleteFMIProduct", fmiproductId);
  }

  public save(
    fmiproduct: FMIProduct,
    template: string,
    model: string,
    currentUser: string
  ): void {
    const strExpirationDate = "";

    this._signalRService.invoke(
      "SaveFMIProduct",
      fmiproduct.Id,
      fmiproduct.FileMetadataID,
      fmiproduct.ProductSourceID,
      fmiproduct.ProductName,
      fmiproduct.ProductDescription,
      fmiproduct.PubType,
      fmiproduct.Language,
      template,
      model,
      fmiproduct.Division,
      fmiproduct.CDPrice,
      fmiproduct.BookPrice,
      fmiproduct.FlashDrivePrice,
      fmiproduct.ProManualTitle,
      fmiproduct.PublishToProManual,
      fmiproduct.ProManualPublicationNumber,
      strExpirationDate,
      fmiproduct.AllowPrinting,
      currentUser,
      fmiproduct.IsPulledFromMidlandFMI,
      fmiproduct.TitaniaUrl
    );
  }

  public saveSectionPermissions(
    userId: number,
    sectionPermissions: SectionPermission[]
  ): void {
    //for (let sectionPermission of sectionPermissions) {
    //	this._signalRService.invoke("SaveSectionPermission", userId, sectionPermission.SectionId, sectionPermission.Allowed);
    //}
  }

  public applyFilter(
    orderBy: string,
    ascending: boolean,
    productName: string,
    productDescription: string,
    fmiLanguage: string,
    division: string,
    createdBy: string,
    ableToPrint: boolean,
    notAbleToPrint: boolean
  ): void {
    this._signalRService.invoke(
      "FilterFMIProducts",
      orderBy,
      ascending,
      productName,
      productDescription,
      fmiLanguage,
      division,
      createdBy,
      ableToPrint,
      notAbleToPrint
    );
  }

  private registerOnServerEvents() {
    this._signalREventService.register(
      "FMIProductService",
      "fmiproducts",
      (info: any) => this.onFMIProducts(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmiproductChange",
      (info: any) => this.onFMIProductChange(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmitemplates",
      (info: any) => this.onFMITemplates(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmidivisions",
      (info: any) => this.onFMIDivisions(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmipubtypes",
      (info: any) => this.onFMIPubTypes(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmimodels",
      (info: any) => this.onFMIModels(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmilanguages",
      (info: any) => this.onFMILanguages(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmiproductsources",
      (info: any) => this.onFMIProductSources(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmiproductCreate",
      (info: any) => this.onCreateFMIProduct(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmiproductSave",
      (info: any) => this.onFMIProductSave(info)
    );
    this._signalREventService.register(
      "FMIProductService",
      "fmiproductDelete",
      (info: any) => this.onFMIProductDelete(info)
    );
  }

  public deregisterOnServerEvents(): void {
    this._signalREventService.deregister("FMIProductService");
  }

  public getProductMetadataBySourceIDAndPubNo(
    searchProductSourceID: number,
    searchOldPublicationNumber: string
  ): Promise<FMIProduct> {
    return this._signalRService.invoke(
      "GetProductMetadataBySourceIDAndPubNo",
      searchProductSourceID,
      searchOldPublicationNumber
    );
  }
}
